export function wpAdminbar() {
    document.addEventListener("keydown", (event) => {
        if (event.isComposing || event.keyCode === 48 || event.keyCode === 96) {
            document.querySelector("body").classList.toggle("show-admin-bar");
        }
    });
}
